import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const TopOffendersWorstSitesCitiesRequest = (values, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RanReportKpis/TopOffendersCitiesWorstSites`,
	data: { userId, values }
});
